var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vs"},[_c('img',{staticStyle:{"width":"9px","margin-top":"-4px"},attrs:{"src":require("@/assets/img/ico/ico_secret.png")}})])
}]

export { render, staticRenderFns }